<template>
  <data-table
    :headers="headers"
    url="api/v1/clients"
    title="Clients"
    item-key="id"
    searchable
    @click:row="showClientDetails"
  >
    <v-btn slot="action.icons" color="primary" tile @click="$emit('update:isCreating', true)">
      <v-icon>mdi-plus</v-icon>
      New Client
    </v-btn>
    <template slot="item.email_verified_at" slot-scope="row">
      <v-icon v-if="row.item.email_verified_at" color="primary">mdi-check-circle-outline</v-icon>
      <v-icon v-else color="warning">mdi-information-outline</v-icon>
    </template>
    <template slot="item.is_healthy" slot-scope="row">
      <v-icon v-if="row.item.is_healthy == true" color="primary">mdi-check-circle-outline</v-icon>
      <v-icon v-else color="red lighten-2">mdi-emoticon-sick</v-icon>
    </template>
  </data-table>
</template>
<script>
export default {
  data() {
    return {
      headers: [
        {
          text: 'First Name',
          value: 'first_name',
        },
        {
          text: 'Last Name',
          value: 'last_name',
        },
        {
          text: 'Company',
          value: 'company',
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: 'Verified Email',
          value: 'email_verified_at',
        },
        {
          text: 'Health',
          value: 'is_healthy',
        },
        {
          text: 'Kubernetes Namespace',
          value: 'kubernetes.namespace',
        },
      ],
    };
  },
  methods: {
    showClientDetails({ id }) {
      this.$router.push({ name: 'clients.show', params: { id } });
    },
  },
};
</script>
